export const siteData = {
  company: {
    name: 'Bretech Solutions Group',
    shortName: 'BSG',
    tagline: 'Marketing that moves the needle',
    copyright: '© 2026 Bretech Solutions Group - All Rights Reserved.',
    founder: 'B. Charlie O\'Bryant',
    logo: 'https://customer-assets-wrfwihn1.emergentagent.net/job_immersive-tech-16/artifacts/w95ueoej_bretech_gold_solutions_group_2.webp',
    symbol: 'https://customer-assets-wrfwihn1.emergentagent.net/job_immersive-tech-16/artifacts/2cdlo5ia_ChatGPT%20Image%20Jul%2016%2C%202026%2C%2011_40_49%20PM.png',
  },
  hero: {
    title: 'Complete Marketing',
    titleAccent: 'Service Solutions',
    subtitle: 'Ready for growth you can measure?',
    description: 'We turn ambitious brands into unforgettable ones — with strategy, design, and AI that actually convert.',
    cta: 'Start Your Project',
  },
  navigation: [
    { label: 'Home', href: '#home' },
    { label: 'About', href: '#about' },
    { label: 'Mission', href: '#mission' },
    { label: 'Services', href: '#services' },
    { label: 'Contact', href: '#contact' },
  ],
  about: {
    label: 'FOUNDER',
    name: 'B. CHARLIE O\'BRYANT',
    role: 'Founder & CEO',
    bio: 'Bretech Solutions Group was built on a simple belief: your brand deserves more than templates and guesswork. We combine strategic thinking, creative craft, and cutting-edge AI to deliver marketing that pays for itself — again and again. Every project is treated like our own, and every client is a long-term partner.',
    image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_immersive-tech-16/artifacts/sl384evj_Charlie%20O_Headshot%202026.webp',
  },
  mission: {
    label: 'OUR MISSION',
    title: 'Excellence in every engagement',
    description: 'We exist to help ambitious businesses punch above their weight. From the first strategy call to the final campaign metric, we obsess over the details others overlook — because that\'s where real growth is hiding. When you win, we win.',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85',
    pillars: [
      { title: 'Quality', desc: 'Work we\'d proudly put our own name on — every deliverable, every time.' },
      { title: 'Care', desc: 'Your goals become ours. We listen first, then build with intention.' },
      { title: 'Professionalism', desc: 'Clear communication, tight deadlines, and results you can defend to any boardroom.' },
    ],
  },
  services: {
    label: 'OUR SERVICES',
    heading: 'A full-stack marketing partner',
    description: 'Strategy. Design. Code. AI. One team, one accountable partner — replacing three agencies and half a dozen freelancers with results you can measure from day one.',
    image: 'https://images.pexels.com/photos/7651801/pexels-photo-7651801.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    items: [
      {
        title: 'AI Certification Experts',
        desc: 'Certified AI strategists who put intelligent automation to work — cutting your workload, personalizing every touchpoint, and giving your team superpowers.',
        tag: '01',
      },
      {
        title: 'Website Design & Build',
        desc: 'Lightning-fast, conversion-obsessed websites that turn visitors into customers — engineered around your brand, your goals, and your bottom line.',
        tag: '02',
      },
      {
        title: 'Graphic Design',
        desc: 'Bold visual identities and campaign assets that stop the scroll, own the room, and stay locked in your customers\' memory.',
        tag: '03',
      },
      {
        title: 'Marketing Strategy',
        desc: 'Data-driven campaigns engineered to grow reach, capture leads, and multiply revenue — with reporting you can actually understand.',
        tag: '04',
      },
      {
        title: 'Media Production & Brand Storytelling',
        desc: 'Cinematic video, editorial photography, and long-form content that turn founders into faces and brands into movements. From social reels to YouTube series, event coverage to behind-the-scenes — we produce, direct, and edit the story your audience actually wants to follow.',
        tag: '05',
      },
    ],
  },
  contact: {
    label: 'GET IN TOUCH',
    heading: 'Let\'s build something remarkable',
    description: 'Tell us where you want to grow — we\'ll show you exactly how to get there. Most projects kick off within a week.',
    email: 'info@bretechsolutions.com',
    phone: '404-692-0544',
    location: 'United States',
  },
};
